<template>
    <div class="binary">
        <div :class="['collapse-title', isPlay ? 'collapse-title-open' : 'collapse-title-default']" @click="handleDisplay">
            <img v-if="isNew" class="tag" src="../../images/downloads/new.png" alt="">
            <div class="icon-display">
                <i :class="['icon-41fenyeyou-01', 'icon-open', isPlay ? 'icon-show' : '']"></i>
            </div>
            <div class="name">
                <div :class="[item.extra_info.release ? 'release': '']">{{item.name}}</div>
            </div>
            <span class="update-time">{{item.desc}}</span>
            <span v-if="isBinary && isPlay" class="update-url" @click.stop="JumpPage(item, 'update')"><i style="font-size: 14px;" class="icon-cc-jump-link-2">升级指引</i></span>
        </div>
        <div :class="['collapse-content', isPlay ? 'content-animation-open' : 'content-animation-close']">
            <template>
                <div class="combo-item" v-for="combo in item.children" :key="combo.name">
                    <div class="combo-head">
                        <span class="combo-name">{{combo.name}}</span>
                        <template v-if="combo.name !== '历史版本升级Patch'">
                            <span v-if="isBinary" class="combo-size">{{combo.extra_info.size}}</span>
                            <span v-if="isBinary" class="combo-md5">MD5：{{combo.extra_info.md5}}</span>
                        </template>
                        <span v-else class="combo-md5">{{historyVersion(combo)}}</span>
                        <template v-if="type === 'binary'">
                            <template v-if="combo.name !== '历史版本升级Patch'">
                                <span class="combo-open" v-if="combo.extra_info.open && combo.extra_info.open !== ''" @click="JumpPage(combo, 'open')"><i style="font-size: 16px; margin-right:5px" class="icon-github-logo"></i>开源地址</span>
                                <span class="combo-download" @click="JumpPage(combo, 'download')">
                                    <i style="font-size: 14px" class="icon-xiazai"></i>
                                    立即下载
                                </span>
                            </template>
                            <template v-else>
                                <span class="combo-download" @click="JumpPage(combo, 'download')">
                                    <i style="font-size: 14px" class="icon-xiazai"></i>
                                    立即下载
                                </span>
                                <span class="combo-update" @click.stop="JumpPage(combo, 'update')"><i style="font-size: 14px; margin-right: 4px;" class="icon-cc-jump-link-2"></i>升级指引</span>
                            </template>
                        </template>
                        <span v-else class="combo-deploy" @click="JumpPage(combo, 'deploy')">前往部署<i style="font-size: 14px" class="icon-cc-jump-link-2"></i></span>
                    </div>
                    <div class="combo-content">
                        <ul class="product" v-for="(product, index) in combo.children" :key="index" :style="{'width' : product.name === '亮点功能' ? 'calc(100% - 520px)' : '260px'}">
                            <template v-if="product.name === '套餐内容'">
                                <li style="font-weight: Bold;color: #313238; margin-bottom: 9px;">{{product.name}}</li>
                                <li v-for="product1 in product.children" :key="product1.name">
                                    <template v-if="product1.name === '更多详细日志'">
                                        <span @click="JumpPage(product1, 'more')" class="more-log"><i style="font-size: 14px;margin-right: 8px;" class="icon-cc-jump-link-2"></i>{{product1.name}}</span>
                                    </template>
                                    <template v-else>
                                        <img style="width: 16px; height: 16px; margin-right: 8px;" :src="product1.resource" alt="">
                                        <span>{{product1.name}}</span>
                                    </template>
                                </li>
                            </template>
                            <template v-if="product.name === '亮点功能'">
                                <li style="font-weight: Bold;color: #313238; margin-bottom: 9px;">{{product.name}}</li>
                                <li v-for="product1 in product.extra_info.update_list" :key="product1">
                                    <span>{{product1}}</span>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'binary',
    props: {
        item: Object,
        type: String,
        isNew: Boolean,
        autoOpen: Boolean
    },
    data () {
        return {
            isPlay: false
        }
    },
    computed: {
        isBinary () {
            return this.type === 'binary'
        },
        isLogin () {
            return this.$store.state.isLogin
        }
    },
    mounted () {
        this.isPlay = this.autoOpen
    },
    methods: {
        handleDisplay () {
            this.isPlay = !this.isPlay
        },
        JumpPage (basic, type) {
            if (type === 'deploy') {
                const cur = basic.children.find(item => item.name === '前往部署')
                if (cur.url) {
                    this.$emit('containerDeployValidate', cur)
                }
                return
            }
            if(type == 'open' || type === 'update') {
                window.open(type === 'open' ? basic.extra_info.open : basic.extra_info.update_url, '_blank')
                return
            }
            if (type === 'download') {
                this.$emit('recordUserDownload', basic)
                return
            }
            if (basic.url) {
                window.open(basic.url, '_blank')
            }
        },
        historyVersion (combo) {
            const { size, md5 } = combo.extra_info
            const [ versionPatch,  applicableVersion] = combo.desc.split('/')
            return `${versionPatch} | ${applicableVersion} | 大小：${size} | MD5：${md5}`
        }
    }
}
</script>

<style lang="scss" scoped>

.binary {
    width: 1200px;
    margin-bottom: 16px;
    .collapse-title {
        display: flex;
        position: relative;
        width: 100%;
        height: 70px;
        line-height: 70px;
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10);
        border-radius: 2px;
        border-bottom: #63656E;
        cursor: pointer;
        .tag {
            position: absolute;
            top: -2px;
            left: -4px;
        }
        .icon-display {
            margin: 0px 2px 0 30px;
            line-height: 75px;
            .icon-open {
                font-size: 20px;
                transform: rotate(0);
                display: inline-block;
                transition: all 0.5s;
            }
            .icon-show {
                transform: rotate(90deg);
            }
        }
        .name {
            width: 260px;
            font-weight: Bold;
            font-size: 18px;
            color: #313238;
            position: relative;
            .release {
                &::after {
                    position: absolute;
                    content: 'Release';
                    top: 16px;
                    right: 104px;
                    width: 46px;
                    height: 18px;
                    background: #e4faf0;
                    color: #11a466;
                    border-radius: 2px;
                    line-height: 18px;
                    font-size: 12px;
                    text-align: center;
                }
            }
        }
        .update-time {
            flex: 1;
            font-size: 12px;
            color: #63656E;
        }
        .update-url {
            margin-right: 42px;
            margin-left: 29px;
            font-size: 12px;
            color: #3A84FF;
            cursor: pointer;
            &:hover {
                color: #1768EF;
            }
        }
        
    }
    .collapse-title-default {
        &:hover {
            box-shadow: 0 2px 8px 0 rgba(0,0,0,0.20);
        }
    }
    .collapse-title-open {
        box-shadow: 0 0 2px 0 rgba(0,0,0,0.10);
    }
    .collapse-content {
        width: 100%;
        height: 0%;
        padding: 24px;
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10);
        border-radius: 2px;
        transition: all 0.25s ease-in-out;
        .combo-item {
            width: 100%;
            .combo-head {
                width: 1152px;
                min-height: 42px;
                line-height: 42px;
                padding-left: 24px;
                padding-right: 16px;
                background: #F5F7FA;
                border-radius: 2px;
                display: flex;
                justify-content: space-between;
                .combo-name {
                    width: 260px;
                    font-weight: Bold;
                    font-size: 14px;
                    color: #313238;
                }
                .combo-size {
                    font-size: 12px;
                    width: 80px;
                    color: #63656E;
                }
                .combo-md5 {
                    flex: 1;
                    font-size: 12px;
                    color: #63656E;
                }
                .combo-open {
                    width: 70px;
                    margin-left: 29px;
                    font-size: 12px;
                    color: #3A84FF;
                    cursor: pointer;
                    &:hover {
                        color: #1768EF;
                    }
                }
                .combo-download {
                    width: 70px;
                    margin-left: 29px;
                    font-size: 12px;
                    color: #3A84FF;
                    cursor: pointer;
                    &:hover {
                        color: #1768EF;
                    }
                }
                .combo-update {
                    width: 70px;
                    margin-left: 29px;
                    font-size: 12px;
                    color: #3A84FF;
                    cursor: pointer;
                    &:hover {
                        color: #1768EF;
                    }
                }
                .combo-deploy {
                    width: 70px;
                    margin-left: 29px;
                    font-size: 12px;
                    color: #3A84FF;
                    cursor: pointer;
                    &:hover {
                        color: #1768EF;
                    }
                }
            }
            .combo-content {
                display: flex;
                font-size: 12px;
                padding: 16px 26px;
                .product {
                    width: 260px;
                    color: #313238;
                    li {
                        margin: 4px 0;
                        display: flex;
                        align-items: center;
                        line-height: 24px;
                    }
                    .more-log {
                        color: #3A84FF;
                        cursor: pointer;
                        &:hover {
                            color: #1768EF;
                        }
                    }
                    
                }
                .update {
                    // width: calc(100% - 520px);
                }
            }
        }
    }
    .content-animation-close {
        // opacity: 0;
        // visibility: hidden;
        // border-top: #63656E;
        display: none;
    }
    .content-animation-open {
        border-top: 1px solid #f5f7fa;
        display: block;
        // opacity: 1;
        // visibility: visible;
    }
}
</style>


// WEBPACK FOOTER //
// binary.vue?63019955